module.exports = __webpack_public_path__ + "img/122.aac01c2a.jpg";